import apiEndpoints from "@/services/apiEndpoints";
import {dateWithWeekDay} from "@/filters";

export default {
  data() {
    return {
      isLoading: false,
      headers: [
        {
          text: '作業年月日',
          name: 'created_at'
        },
        {
          text: '作業者',
          name: 'user_name_created_by'
        },
        {
          text: '申し送り事項',
          name: 'remarks'
        },
      ],
      data: [],
      workOrderId: null,
      workOrderName: ''
    }
  },
  methods: {
    async getData() {
      if (!this.workOrderId) return;

      this.isLoading = true;
      const url = apiEndpoints.histories_by_work_order(this.workOrderId);
      const {status, data} = await this.$http.get(url);
      if (status) {
        this.data = this.transferData(data.result);
      }
      this.isLoading = false;
    },
    transferData(data) {
      return data.map(item => {
        const formattedDate = dateWithWeekDay(item.start_datetime);

        return {...item, start_datetime: formattedDate};
      });
    },
    closeModal() {
      this.$bvModal.hide("modal-work-history");
    },
    openModal(id, name) {
      this.workOrderId = id;
      this.workOrderName = name;
      this.$nextTick(() => this.$bvModal.show("modal-work-history"));
    },
    getUserName(item){
      //スケジュール.割当人員のリレーションから取得
      let users = item.schedule.assigned_staffs_by_schedule;
      return users.map(item=>item.user_name).join(",");
    }
    
  },
}
